export default __webpack_public_path__ + "static/Group 30-65fc9b58fcc2e6a6b6841981d32c0857.png";